import { render } from "./CardRequest.vue?vue&type=template&id=388d4278&scoped=true"
import script from "./CardRequest.vue?vue&type=script&lang=js"
export * from "./CardRequest.vue?vue&type=script&lang=js"

import "./CardRequest.vue?vue&type=style&index=0&id=388d4278&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d4278"]])

export default __exports__